import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { LineOfBusinessRule } from '../../../models/feature-flag.model';
import { AbstractListRuleComponent } from './abstract-list-rule.component';

/**
 * Component for building and managing line of business-based targeting rules
 */
@Component({
  selector: 'cbre-line-of-business-rule',
  templateUrl: './line-of-business-rule.component.html',
  styleUrls: ['./line-of-business-rule.component.scss'],
  standalone: false,
})
export class LineOfBusinessRuleComponent extends AbstractListRuleComponent<LineOfBusinessRule> {
  /**
   * The rule type identifier
   */
  protected ruleType = 'lineOfBusiness';

  /**
   * Common lines of business for quick selection
   * This could be expanded or loaded from configuration
   */
  protected commonItems = ['US General', 'Tri-state Research', 'US Broker'];

  /**
   * Error message for duplicates
   */
  protected duplicateErrorMessage = 'This line of business is already in the list';

  constructor(protected override fb: FormBuilder) {
    super(fb);
  }
}
